import { get, post, put, deleted } from '..';
import routes from './routes';

const ServiceTypeServices = {
  createServiceType: async (obj) => {
    const data = await post(routes.createServiceType, obj);
    return data;
  },
  getServiceTypes: async (params) => {
    const data = await get(routes.getServiceTypes, params);
    return data;
  },
  getServiceTypeById: async (id) => {
    const data = await get(routes.getServiceTypeById + id);
    return data;
  },
  updateServiceType: async (id, obj) => {
    const data = await put(routes.updateServiceType + id, obj);
    return data;
  },
  deleteServiceType: async (id) => {
    const data = await deleted(routes.deleteServiceType + id);
    return data;
  },
}

export default ServiceTypeServices